.thread-list {
  width: min(20dvw, 20rem);
  height: 100cqh;
  overflow-y: auto;
}

.thread-list-items {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
  padding: var(--mantine-spacing-sm);
  overflow-y: auto;
}

.thread-list-item {
  display: flex;
  gap: var(--mantine-spacing-sm);
  align-items: center;
  padding: calc(var(--mantine-spacing-xs) * 0.5) var(--mantine-spacing-sm);
  cursor: pointer;
  border-radius: var(--mantine-radius-sm);

  &:hover {
    background: alpha(var(--mantine-color-dark-6), 0.5);
  }

  &.main-thread {
    background: var(--mantine-color-dark-6);
  }
}

.thread-list-item-trigger {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--mantine-font-size-sm);
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
  background: transparent;
  border: none;
}
